import { Text } from "@mantine/core"
import { Trans } from "react-i18next"

export function getErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const axiosErr = err as { response?: { data?: { message?: string } } }
    if (axiosErr.response?.data?.message) {
      return axiosErr.response.data.message
    }
  }
  if (err instanceof Error) return err.message
  return String(err)
}

export function EmptyValue() {
  return (
    <Text size="sm" fs="italic" c="gray.5">
      <Trans i18nKey="common.notFilled" />
    </Text>
  )
}
